import script from "./date.vue?vue&type=script&lang=ts&setup=true"
export * from "./date.vue?vue&type=script&lang=ts&setup=true"

import "./date.vue?vue&type=style&index=0&id=53522542&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53522542"]])

export default __exports__